import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountries } from "../../redux/commons/commonSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchVatCountries = () => {
  const dispatch = useDispatch<AppDispatch>();
  const shouldFetch = useRef(true);
  const { countries, loading, error } = useSelector((state: StoreState) => state.common);

  useEffect(() => {
    if (countries.length === 0 && shouldFetch.current) {
      shouldFetch.current = false;
      dispatch(getCountries());
    }
  }, [countries, dispatch]);

  return { loading, error, countries };
};

export default useFetchVatCountries;
